import {
  AuthStateContextType,
  DomainPermission
} from '@percent/admin-dashboard/context/auth/authContext/AuthContext.types'
import { Action } from './authReducer.types'
import { logger } from '@percent/admin-dashboard/common/utility/logger'

export const SET_AUTHORISED = 'auth/set-authorised'
export const SET_UNAUTHORISED = 'auth/set-unauthorised'
export const START_AUTHORISING = 'auth/start-authorising'
export const SET_LOGOUT = 'auth/set-logout'
export const SET_PERMISSIONS = 'auth/set-permissions'
export const SET_PERMISSIONS_ERROR = 'auth/set-permissions-error'
export const TRIGGER_PERMISSIONS_REFETCH = 'auth/trigger-permissions-refetch'

export const initialState: AuthStateContextType = {
  isAuthorised: false,
  isAuthorising: false,
  user: undefined,
  permissionsSet: false,
  permissions: [] as DomainPermission[],
  shouldRefetchPermissions: false
}

export const initializer = (initialValue = initialState): AuthStateContextType => {
  try {
    const storedState = localStorage.getItem('authState')

    if (storedState) {
      const parsedState = JSON.parse(storedState)

      return {
        isAuthorised: parsedState.isAuthorised || initialValue.isAuthorised,
        isAuthorising: parsedState.isAuthorising || initialValue.isAuthorising,
        user: parsedState.user || initialValue.user,
        permissionsSet: parsedState.permissionsSet || initialValue.permissionsSet,
        permissions: parsedState.permissions || initialValue.permissions,
        shouldRefetchPermissions: initialValue.shouldRefetchPermissions
      }
    }
  } catch (error) {
    logger(error as Error)
  }

  return initialValue
}

export const authReducer: (state: AuthStateContextType, action: Action) => AuthStateContextType = (state, action) => {
  switch (action.type) {
    case START_AUTHORISING:
      return {
        ...state,
        isAuthorising: true,
        permissionsSet: false
      }
    case SET_AUTHORISED:
      return {
        ...state,
        user: action.user,
        isAuthorising: false,
        isAuthorised: true
      }
    case SET_PERMISSIONS:
      // A permissions request still running when the admin signed out answers for that session,
      // not for whoever signs in next
      if (!state.isAuthorised) return state

      return {
        ...state,
        permissions: action.permissions || [],
        permissionsSet: true,
        shouldRefetchPermissions: false
      }
    case SET_PERMISSIONS_ERROR:
      if (!state.isAuthorised) return state

      return {
        ...state,
        permissionsSet: true,
        shouldRefetchPermissions: false
      }
    case TRIGGER_PERMISSIONS_REFETCH:
      // A 403 while signed out (a non-admin's refused login) has no permissions to refresh, and
      // asking for them then answers 401, which would end on the expired-session page.
      if (!state.isAuthorised) return state

      return {
        ...state,
        shouldRefetchPermissions: true
      }
    case SET_UNAUTHORISED:
    case SET_LOGOUT:
      return {
        ...state,
        user: undefined,
        isAuthorising: false,
        isAuthorised: false,
        permissionsSet: false,
        permissions: [],
        shouldRefetchPermissions: false
      }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}
